/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { tint } from 'polished';
import dynamic from 'next/dynamic';
import { nanoid } from 'nanoid';
import { stripe } from '@/lib/_stripe';
import getUserById from '@/lib/_user/_getUserById';
import { useRouter } from 'next/router';
import { getURL } from '@/utils/index';
import Link from 'next/link';
import useSWR from 'swr';
// import { Auth } from 'aws-amplify';
import { Icon } from 'react-icons-kit';
import { ic_mode_edit } from 'react-icons-kit/md/ic_mode_edit';
import { ic_close } from 'react-icons-kit/md/ic_close';
import { ic_info_outline } from 'react-icons-kit/md/ic_info_outline';
import { format } from 'date-fns';
import { ic_chevron_right } from 'react-icons-kit/md/ic_chevron_right';
import { ic_autorenew } from 'react-icons-kit/md/ic_autorenew';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye';
import { ic_vpn_key } from 'react-icons-kit/md/ic_vpn_key';
import { trashO } from 'react-icons-kit/fa/trashO';
import { ic_expand_less } from 'react-icons-kit/md/ic_expand_less';
import { ic_expand_more } from 'react-icons-kit/md/ic_expand_more';
import { getSession, signOut } from 'next-auth/client';
import { localLogout, setLocalSession, updateSession } from '@/utils/auth';
// import { StyledTopNav, DashboardPageWrapper } from '@/styles/index';
import { axiosFetcher, updateUser, updateUserSubscriptions, deleteUser } from '@/utils/data';
import { ViewWrapper, SinglePageWrapper, ProfilePageWrapper } from '@/styles/index';
import UserNavbar from '@/components/Layout/Navbar/UserNavbar';
import Avatar from '@/components/Layout/Avatar';
import HeadMeta from '@/components/HeadMeta';
// import Footer from '@/components/Layout/Footer';
import { createBillingPortalSession } from 'next-stripe/client';
import SplashLoader from '@/components/SplashLoader';
// import Tippy from '@/components/Tooltip';
const Tippy = dynamic(() => import('@/components/Tooltip'), { ssr: false });
const Footer = dynamic(() => import('@/components/Layout/Footer'));
const PollmeFeedbackButton = dynamic(() => import('@/components/PollmeFeedbackButton'));

// check https://track.toggl.com/subscription/5628765/overview (dialnco@gmail.com) for inspo

export const Collapsible = styled.div`
  opacity: ${props => (props.open ? '1' : '0')};
  max-height: ${props => (props.open ? '100%' : '0')};
  overflow: hidden;
  ${'' /* padding: ${props => (props.open ? '1rem' : '0.5rem 1rem')}; */}
  ${'' /* padding-bottom: 1rem; */}
  transition: all 0.3s ease-in-out;
`;

const BlockCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 13%) 0px 2px 6px 0px;
  border-radius: var(--border-radius);
  margin: 1.5rem 0;
  ${'' /* min-height: 164px; */}
  width: 100%;
  padding: 1.25rem 2.25rem;
  padding-bottom: 0;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    padding: 1.25rem 1.5rem;
    padding-bottom: 0;
  }
`;

const Tag = styled.span`
  margin: 0;
  margin-left: 0.5rem;
  background-color: cyan;
  color: var(--text-color);
  padding: 2px 0.75rem;
  border-radius: var(--border-radius);
  border: 1px solid;
  color: ${({ subscription }) => (subscription ? 'var(--blue)' : 'var(--green)')};
  border-color: ${({ subscription }) => (subscription ? 'var(--blue)' : 'var(--green)')};
  background-color: ${({ subscription, theme }) =>
    subscription ? tint(0.9, theme.colors.blue) : tint(0.9, theme.colors.green)};
`;

const BlockHeader = styled.div`
  display: grid;
  grid-template-columns: ${({ showActions }) => (showActions ? 'auto 25%' : '1fr')};
  align-items: start;
  grid-gap: 0.5rem;
  padding-bottom: 1.25rem;
  padding-top: 0.25rem;
  border-bottom: 1px solid var(--muted);
  .header-info {
    display: grid;
    grid-gap: 0.25rem;
    grid-auto-flow: row;
    &.btn {
      background-color: transparent;
      text-align: initial;
    }
    .header-title {
      font-size: 1rem;
      font-weight: 600;
      margin: 0;
    }
    .header-description {
      font-size: 1rem;
      color: var(--muted-strong);
      font-family: var(--font-base);
    }
  }
  .header-actions {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 1rem;
    color: var(--muted-strong);
    font-family: var(--font-base);
  }
  .header-toggle {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .toggle-btn {
      margin: 0;
      padding: 0.5rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    grid-template-columns: ${({ showActions }) => (showActions ? '1fr' : '1fr')};
    .header-actions {
      justify-content: center;
    }
    .header-toggle {
      justify-content: center;
    }
  }
`;

const BlockBody = styled.div`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  .delete-option {
    padding: 1.5rem 0;
    button {
      padding: 0.5rem 1rem;
      font-size: 0.875rem;
      color: var(--muted-strong);
    }
  }
  .delete-confirm {
    padding-top: 1.5rem;
    button {
      padding: 0.5rem 1rem;
      font-size: 0.875rem;
      color: var(--white);
      background-color: var(--red);
      &:hover {
        background-color: var(--red-hover);
      }
    }
    .account-remove-tooltip {
      padding: 0.5rem;
      .tooltip-label {
        padding: 0.5rem;
        border-radius: var(--border-radius);
        background-color: var(--danger-background);
        color: var(--danger);
        font-weight: 700;
      }
      .tooltip-info-text {
        padding: 0.5rem;
      }
    }
    .remove-footer {
      padding: 0.5rem 0;
      .btn-cancel {
        width: 150px;
        margin-left: 5px;
        color: var(--muted-strong);
        background-color: var(--white);
        border: var(--border);
        &:hover {
          background-color: var(--white-hover);
        }
      }
    }
  }
  .input-group {
    padding-bottom: 1rem;
    .label {
      font-size: 0.875rem;
      font-weight: 600;
      color: var(--muted-strong);
      padding-bottom: 0.5rem;
      .label-actions {
        button {
          font-size: 0.7rem;
          margin-left: 5px;
          color: var(--muted-strong);
        }
      }
    }
    .input-wrapper {
      width: 100%;
      display: grid;
      grid-template-columns: auto 150px;
      grid-gap: 0.5rem;
      align-items: center;
      input {
        display: block;
        width: 100%;
        margin: 0 auto;
        border-radius: var(--border-radius);
        border: var(--border);
        padding: 0.75rem;
        font-size: 1.1rem;
        color: var(--text-color);
        height: 32px;
        &:disabled {
          background-color: var(--white);
        }
      }
      button {
        height: 100%;
        width: 100%;
        border: var(--border);
        border-left: 0;
        background-color: var(--blue);
        color: var(--white);
        outline: none;
        &:hover {
          background-color: var(--blue-hover);
        }
      }
    }
  }
  .share-action {
    width: 100%;
    button {
      font-size: 0.875rem;
      padding: 0.5rem;
      height: 100%;
      width: 100%;
      border: 1px dashed var(--muted-strong);
      background-color: var(--white);
      outline: none;
      &:hover {
        background-color: var(--white-hover);
      }
      &:disabled {
        color: var(--muted-strong);
        background-color: var(--muted);
      }
    }
  }
  .share-link {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 64px;
    align-items: center;
    &.with-hide {
      grid-template-columns: 1fr 32px 150px;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
        grid-template-columns: 1fr !important;
      }
    }
    input {
      display: block;
      width: 100%;
      margin: 0 auto;
      border-radius: var(--border-radius);
      border: var(--border);
      padding: 0.75rem;
      font-size: 1.1rem;
      color: var(--text-color);
      height: 32px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &:disabled {
        background-color: var(--white);
      }
      &.blur-text {
        color: transparent;
        text-shadow: 3px 0 5px rgba(0, 0, 0, 0.5);
      }
    }
    button {
      height: 100%;
      width: 100%;
      border: var(--border);
      border-left: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      background-color: var(--blue);
      color: var(--white);
      outline: none;
      &:hover {
        background-color: var(--blue-hover);
      }
      &.action-blur {
        background-color: var(--white);
        color: inherit;
        &:hover {
          background-color: var(--white-hover);
        }
        border-right: 0;
        border-radius: 0;
      }
    }
  }
`;

const OptionCard = ({
  showHeader = true,
  title = '',
  description = '',
  actions,
  children,
  opened = true,
  showToggle
}) => {
  const [open, setOpen] = useState(opened);
  const showActionsLayout = actions || showToggle;
  return (
    <BlockCardWrapper>
      {showHeader && (
        <BlockHeader showActions={showActionsLayout}>
          {showToggle ? (
            <button type="button" className="header-info btn" onClick={() => setOpen(!open)}>
              <h3 className="header-title">{typeof title === 'function' ? title() : title}</h3>
              <div className="header-description">
                {typeof description === 'function' ? description() : description}
              </div>
            </button>
          ) : (
            <div className="header-info">
              <h3 className="header-title">{typeof title === 'function' ? title() : title}</h3>
              <div className="header-description">
                {typeof description === 'function' ? description() : description}
              </div>
            </div>
          )}
          {actions && <div className="header-actions">{actions}</div>}
          {showToggle && (
            <div className="header-toggle">
              <button type="button" className="toggle-btn" onClick={() => setOpen(!open)}>
                <Icon size={20} icon={open ? ic_expand_less : ic_expand_more} />
              </button>
            </div>
          )}
        </BlockHeader>
      )}
      <Collapsible open={open}>
        <BlockBody>{children}</BlockBody>
      </Collapsible>
    </BlockCardWrapper>
  );
};

export async function getServerSideProps(context) {
  // console.log('server session');
  const session = await getSession(context);
  let user = null;
  let products = [];
  if (session) {
    user = await getUserById(session?.user?.userID);
    // console.log({ session });
    const prices = await stripe.prices.list({
      active: true,
      limit: 10,
      expand: ['data.product']
    });
    products = user.stripeSubscriptions.items
      .map(sub => {
        const priceObject = prices.data.find(price => price.id === sub.price_id);
        if (priceObject) {
          return { price_id: priceObject.id, ...priceObject.product };
        }
        return null;
      })
      .filter(Boolean);
  }
  // console.log({ session });
  return {
    props: { session, user, products }
  };
}

// const ExternalProviders = ['google'];

const Profile = ({ session, user, products }) => {
  // console.log({ products });
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [loadingPortal, setLoadingPortal] = useState(false);
  const [editName, setEditName] = useState(false);
  const [name, setName] = useState('');
  const [showDeleteTooltip, setShowDeleteTooltip] = useState(false);
  const [showDeleteInput, setShowDeleteInput] = useState(false);
  const [showApiKeys, setShowApiKeys] = useState(false);
  const [showNotionKeys, setShowNotionKeys] = useState(false);
  const [deleteInput, setDeleteInput] = useState('');
  const [apiKey, setApiKey] = useState(user.apiKey);
  const [loadingSecret, setLoadingSecret] = useState(false);
  const [integrationNotionKey, setIntegrationNotionKey] = useState(user.integrationNotionKey);

  const { sub: subscriptionRefresh } = router.query;
  // const router = useRouter();
  // console.log({ session });

  // ––– URL PARAMS ACTIONS
  // if query accessKey, set local accessKey
  async function updateUserSubscriptionInfo() {
    // console.log('update user sub status');
    // console.log({ user });
    const subscriptionsIds = user.stripeSubscriptions.items.map(sub => sub.id);
    // console.log({ subscriptionsIds });
    await updateUserSubscriptions({ subscriptionsIds });
    // update current user session to account for posible subscription changes
    await updateSession(session);
    // refresh page
    if (router) {
      const newQuery = { ...router.query };
      delete newQuery.sub;
      router.push({
        pathname: `/account`,
        query: { ...newQuery }
      });
    }
  }

  useEffect(() => {
    // console.log({ router });
    if (subscriptionRefresh) {
      if (subscriptionRefresh === 'stripe') {
        updateUserSubscriptionInfo();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionRefresh]);
  // ––– END URL PARAMS ACTIONS

  // https://swr.vercel.app/docs/arguments
  const { data, error, mutate } = useSWR(
    [`/api/user`, JSON.stringify({})],
    (url, options) => axiosFetcher(url, JSON.parse(options))
    // { initialData: poll } // https://swr.vercel.app/docs/with-nextjs
    // doesn't work on this case, as we need an initial call to check if owner or not
  );

  useEffect(() => {
    if (data) {
      if (data.user.name) {
        setName(data.user.name);
        setApiKey(data.user.apiKey);
        setIntegrationNotionKey(data.user.integrationNotionKey);
      }
    }
  }, [data]);

  if (!session) {
    return <div>No session</div>;
  }

  // console.log({ session });
  // console.log({ data, error, mutate });

  const handleGenerateApiSecretKeys = async newKeys => {
    // if not subscription user, return early
    await setLoadingSecret(true);
    // console.log({ newKeys });
    const input = {
      apiKey: newKeys,
      apiKeyIssued: new Date()
    };
    await updateUser(input);
    await mutate(); // revalidate SWR
    await setLoadingSecret(false);
  };

  const onUpdateUser = async values => {
    await setLoading(true);
    const input = { ...values };
    await updateUser(input);
    await mutate(); // revalidate SWR
    await setEditName(false);
    await setLoading(false);
  };

  const onUpdateNotionIntegration = async () => {
    await setLoading(true);
    const input = { integrationNotionKey };
    await updateUser(input);
    await mutate(); // revalidate SWR
    await setEditName(false);
    await setLoading(false);
  };

  const handleBillingPortal = async () => {
    await setLoadingPortal(true);
    // cus_JMdK69OzphAzhf
    // const customerID = 'cus_JMdK69OzphAzhf';
    const customerID = data?.user.stripeCustomerID;
    try {
      const portalSession = await createBillingPortalSession({
        customer: customerID,
        // return_url: window.location.href
        return_url: `${getURL()}/account?sub=stripe`
      });
      // console.log({ portalSession });
      if (portalSession) {
        window.location.assign(portalSession.url);
      }
    } catch (err) {
      console.log(err);
      await setLoadingPortal(false);
    }
  };

  const onLogOut = async () => {
    try {
      await localLogout(); // clear local storage data
      const outData = await signOut({ redirect: false, callbackUrl: '/' });
      // console.log({ outData });
      // router.replace('/');
      // router.push(outData.url);
      router.push('/');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  };

  const handleDeleteAccount = async () => {
    // console.log('delete account!');
    await setLoading(true);
    const input = { id: user.id };
    // console.log(input);
    try {
      await deleteUser(input);
      await onLogOut();
    } catch (err) {
      console.log(err);
      await setLoading(false);
    }
  };

  // const isExternalEmailProvider = ExternalProviders.includes(session.user.provider);

  const subscriptions = data?.user.stripeSubscriptions.items || [];
  const activeSubscriptions = subscriptions.filter(sub => sub.status === 'active');
  const canceledSubs = activeSubscriptions.filter(sub => sub.cancel_at_period_end);
  const activeNewSubs = activeSubscriptions.filter(sub => !sub.cancel_at_period_end);
  const canAccessCustomerPortal = subscriptions.length > 0 && !!data?.user.stripeCustomerID;
  const currentPlan = activeNewSubs.length > 0 && activeNewSubs[0];
  const currentProduct =
    currentPlan && products.find(prod => prod.price_id === currentPlan.price_id);
  // console.log({ activeNewSubs, currentPlan, currentProduct });
  return (
    <ViewWrapper>
      <HeadMeta
        title={
          session.user.name
            ? `Account - ${session.user.name}, Pollme`
            : `Account - ${session.username}, Pollme`
        }
      />
      <UserNavbar session={session} user={data?.user} />
      <SinglePageWrapper>
        <ProfilePageWrapper>
          <h1>Account</h1>
          <div className="option-group">
            <h2>Overview</h2>
            <div className="user-info">
              <div className="user-image">
                <Avatar session={session} large width={100} height={100} />
              </div>
              <div className="user-contact">
                <div className="contact-label">
                  {editName ? (
                    <input
                      id="name"
                      name="name"
                      placeholder="Your name..."
                      value={name}
                      onChange={e => setName(e.target.value)}
                      disabled={loading}
                    />
                  ) : (
                    data?.user.name || session?.user.name
                  )}
                  <span className="contact-edit">
                    {editName && (
                      <button
                        type="button"
                        disabled={loading}
                        className="btn-primary"
                        onClick={() => onUpdateUser({ name })}
                      >
                        <Icon size={12} icon={ic_mode_edit} /> Update
                      </button>
                    )}
                    <button type="button" disabled={loading} onClick={() => setEditName(!editName)}>
                      <Icon size={12} icon={editName ? ic_close : ic_mode_edit} />{' '}
                      {editName ? 'Cancel' : 'Edit Name'}
                    </button>
                  </span>
                </div>

                <div className="contact-label">{data?.user.username}</div>

                <div className="contact-provider">
                  {session.user.provider === 'credentials' && (
                    <Link href="/account/update-password">
                      <a>Update Password</a>
                    </Link>
                  )}
                  {session.user.provider === 'google' && 'Logged with Google'}
                </div>
              </div>
            </div>
          </div>
          {/**
                    <div className="option-group">
            <h2>Email preferences</h2>
          </div>
           */}

          <div className="option-group">
            <h2>Plan & Subscription</h2>
            {data && (
              <OptionCard
                title="My Plan"
                description={
                  currentPlan
                    ? `Your subscription will be renewed on ${format(
                        new Date(currentPlan.current_period_end),
                        'MMM dd, YYY'
                      )}`
                    : 'You are on the Free plan. No actions required.'
                }
                actions={
                  <div className="action-item">
                    Your current plan:{' '}
                    <Tag subscription={currentProduct}>
                      {currentProduct
                        ? currentProduct.metadata.isProUser
                          ? 'Pro'
                          : 'Premium'
                        : 'Free'}
                    </Tag>
                  </div>
                }
              >
                {activeSubscriptions.length > 0 && (
                  <div className="subscriptions-list">
                    {canceledSubs.length > 0 && (
                      <div className="subscription-block">
                        <div>
                          <h3 style={{ margin: 0 }}>Canceled Subscriptions:</h3>
                        </div>
                        <div>
                          {canceledSubs.map(sub => {
                            // console.log({ sub });
                            const product = products.find(prod => prod.price_id === sub.price_id);
                            if (!product) {
                              return null;
                            }
                            return (
                              <div key={sub.id}>
                                <div className="plan-title">
                                  {product.name}{' '}
                                  <span>
                                    Finishing at:{' '}
                                    <strong>
                                      {format(new Date(sub.cancel_at), 'MMM do, YYY')}
                                    </strong>
                                  </span>
                                </div>
                                <div className="plan-description">{product.description}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {activeNewSubs.length > 0 && (
                      <div className="subscription-block">
                        <div>
                          <h3 style={{ margin: 0 }}>Current Subscriptions:</h3>
                        </div>
                        <div>
                          {activeNewSubs.map(sub => {
                            // console.log({ sub });
                            const product = products.find(prod => prod.price_id === sub.price_id);
                            if (!product) {
                              return null;
                            }
                            return (
                              <div key={sub.id}>
                                <div className="plan-title">
                                  {product.name}{' '}
                                  {/* <span>
                                    Automatic renew at:{' '}
                                    <strong>
                                      {format(new Date(sub.current_period_end), 'MMM do, YYY')}
                                    </strong>
                                  </span> */}
                                </div>
                                <div className="plan-description">{product.description}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="billing-option">
                  {data?.user.stripeCustomerID ? (
                    <>
                      <div>
                        <h3 style={{ margin: 0 }}>Billing Information:</h3>
                      </div>
                      <div>
                        {' '}
                        {data?.user.stripeCustomerID ? (
                          <span>
                            We partnered with Stripe to manage your billing information. Click on
                            the button below to review your data, subscriptions, payment methods,
                            and invoices.
                          </span>
                        ) : (
                          <span>
                            We partnered with Stripe to manage your billing information. Once you
                            start using one of our premium plans, you will have access to your data
                            and invoices.
                          </span>
                        )}
                      </div>
                      <br />
                      <button
                        type="button"
                        onClick={handleBillingPortal}
                        disabled={!canAccessCustomerPortal || loadingPortal}
                      >
                        Manage billing{' '}
                        {loadingPortal ? (
                          <Icon
                            icon={ic_autorenew}
                            className={`${loadingPortal ? 'updating' : ''}`}
                          />
                        ) : (
                          <Icon icon={ic_chevron_right} />
                        )}
                      </button>
                      <div style={{ fontSize: '0.8rem', marginTop: '0.25rem' }}>
                        You will be redirected to Stripe portal
                      </div>
                    </>
                  ) : (
                    <div>
                      <div>
                        Explore the extra features you can unlock with our premium plans. Embed your
                        Polls, remove ads, custom Polls URLs and much more!
                      </div>
                      <br />
                      <Link href="/premium">
                        <a>
                          <button type="button">
                            Check our Pro and Premium plans <Icon icon={ic_chevron_right} />
                          </button>
                        </a>
                      </Link>
                    </div>
                  )}
                </div>
              </OptionCard>
            )}
          </div>

          {data && (
            <div className="option-group">
              <h2>Integrations</h2>
              <OptionCard
                title="Zapier Integration"
                description="Create a new Zapier workflow and trigger your actions on new poll responses"
                showToggle
                opened={false}
              >
                <div>
                  Connect with Zapier and integrate your polls with hundreds of applications and
                  automations right out the bat. Create a new Zapier workflow and trigger your
                  actions on new poll responses. Check the{' '}
                  <Link href="/guides/zapier-integration">
                    <a>Zapier integration Guide</a>
                  </Link>
                  .
                </div>
                <div className="group-options">
                  <div className="input-group">
                    <br />
                    <div className="label">Username</div>
                    <div className="input-wrapper">
                      <div className="muted-label">{user?.username}</div>
                    </div>
                  </div>

                  <div className="input-group">
                    <div className="label">
                      User API Keys {apiKey ? '|' : ''}
                      {apiKey && (
                        <span className="label-actions">
                          <button
                            type="button"
                            disabled={loadingSecret || loading}
                            onClick={() => handleGenerateApiSecretKeys(`key_${nanoid(36)}`)}
                          >
                            {loadingSecret ? 'Generating...' : 'Generate new Api Keys'}
                          </button>
                          <button
                            type="button"
                            disabled={loadingSecret || loading}
                            onClick={() => handleGenerateApiSecretKeys(null)}
                          >
                            Delete Keys
                          </button>
                        </span>
                      )}
                    </div>
                    {apiKey ? (
                      <div className="share-link with-hide">
                        <input value={apiKey} disabled className={showApiKeys ? '' : 'blur-text'} />

                        <Tippy content={showApiKeys ? 'Hide text' : 'Show text'}>
                          <button
                            type="button"
                            className="action-blur"
                            onClick={() => setShowApiKeys(!showApiKeys)}
                          >
                            <Icon icon={showApiKeys ? eyeOff : eye} />
                          </button>
                        </Tippy>

                        <Tippy content="User API Key copied to your clipboard" trigger="click">
                          <button
                            type="button"
                            onClick={() => navigator.clipboard.writeText(apiKey)}
                          >
                            Copy
                          </button>
                        </Tippy>
                      </div>
                    ) : (
                      <div className="share-action">
                        <button
                          disabled={loadingSecret || loading}
                          type="button"
                          onClick={() => handleGenerateApiSecretKeys(`key_${nanoid(36)}`)}
                        >
                          {loadingSecret ? 'Generating...' : 'Generate User API Key'}{' '}
                          <Icon icon={ic_vpn_key} />
                        </button>
                      </div>
                    )}
                    <div className="option-details">
                      <small>
                        {apiKey
                          ? 'This is your User API Key. Do not share this information with other users.'
                          : 'API Keys are specific for your account, and are used to access your polls data from other sources.'}
                      </small>
                    </div>
                  </div>
                </div>
              </OptionCard>
              <OptionCard
                title="Notion Integration (beta)"
                description="Connect your Poll responses with a custom Notion Database with your own Notion integration"
                showToggle
                opened={false}
              >
                <div>
                  Create a new Notion Integration (
                  <a
                    href="https://www.notion.so/my-integrations"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.notion.so/my-integrations
                  </a>
                  ) and configure your workspace integration with the provided Notion Internal
                  Integration Token.
                </div>
                <br />
                <div>
                  Connect your Poll responses with a custom Notion Database to unify your workflow
                  and develop your own Notion integrations. You need to set your custom integration{' '}
                  <em>Notion Token</em> and connect your Notion DB to an individual Poll (on
                  individual Poll settings). You can read more about on the{' '}
                  <Link href="/guides/notion-integration">
                    <a>Notion integration Guide</a>
                  </Link>
                  .
                </div>

                {integrationNotionKey ? (
                  <div className="group-options">
                    <div className="input-group">
                      <br />
                      <div className="label">Notion Internal Integration Token</div>
                      <div className="share-link with-hide">
                        <input
                          value={integrationNotionKey || ''}
                          placeholder="e.g., secret_xxxxxxx..."
                          onChange={e => setIntegrationNotionKey(e.target.value)}
                          disabled={loading}
                          className={showNotionKeys ? '' : 'blur-text'}
                        />
                        <Tippy content={showNotionKeys ? 'Hide text' : 'Show text'}>
                          <button
                            type="button"
                            className="action-blur"
                            onClick={() => setShowNotionKeys(!showNotionKeys)}
                          >
                            <Icon icon={showNotionKeys ? eyeOff : eye} />
                          </button>
                        </Tippy>
                        <button
                          type="button"
                          onClick={onUpdateNotionIntegration}
                          disabled={!showNotionKeys}
                        >
                          {loading ? 'Updating...' : 'Update Notion Keys'}
                        </button>
                      </div>
                    </div>
                    <div className="option-details">
                      <small>
                        Check our{' '}
                        <Link href="/guides/notion-integration">
                          <a>Notion integration Guide</a>
                        </Link>
                        .
                      </small>
                    </div>
                  </div>
                ) : (
                  <div className="group-options">
                    <div className="input-group">
                      <div className="label">Notion Internal Integration Token</div>
                      <div className="input-wrapper">
                        <input
                          value={integrationNotionKey || ''}
                          placeholder="e.g., secret_xxxxxxx..."
                          onChange={e => setIntegrationNotionKey(e.target.value)}
                          disabled={loading}
                        />
                        <button type="button" onClick={onUpdateNotionIntegration}>
                          {loading ? 'Updating...' : 'Set Notion Key'}
                        </button>
                      </div>
                    </div>
                    <div className="option-details">
                      <small>How to set your Notion integration</small>
                    </div>
                  </div>
                )}
              </OptionCard>
            </div>
          )}

          {data && (
            <div className="option-group last">
              <h2>Danger</h2>
              <OptionCard
                title={() => (
                  <span>
                    Delete your account <Icon icon={trashO} />
                  </span>
                )}
                description="Remove all your data and close your account."
                showToggle
                opened={false}
              >
                <div>
                  Once you delete your account, <strong>there is no going back</strong>. Please be
                  sure you want to delete your account with all your data.
                </div>
                <div className="delete-option">
                  <button
                    type="button"
                    disabled={loading}
                    onClick={() => setShowDeleteInput(!showDeleteInput)}
                  >
                    Delete your account
                  </button>
                </div>
                {showDeleteInput && (
                  <div>
                    <input value={deleteInput} onChange={e => setDeleteInput(e.target.value)} />
                    <div className="option-details">
                      <small>Write "DELETE" to confirm delete and continue</small>
                    </div>
                  </div>
                )}
                {showDeleteInput && deleteInput === 'DELETE' && (
                  <div className="group-options">
                    <div className="delete-confirm">
                      <Tippy
                        theme="light"
                        visible={showDeleteTooltip}
                        onClickOutside={() => setShowDeleteTooltip(false)}
                        interactive
                        content={
                          <div className="account-remove-tooltip">
                            <div className="tooltip-label">
                              <Icon size={16} icon={ic_info_outline} /> Are you sure?
                            </div>
                            <div className="tooltip-info-text">
                              Deleting your account will destroy all your polls, submission
                              responses, and other linked data. <br />
                              This action cannot be undone.
                            </div>
                            <div className="remove-footer">
                              <button
                                type="button"
                                disabled={loading}
                                className="btn-remove"
                                onClick={handleDeleteAccount}
                              >
                                Remove
                              </button>
                              <button
                                type="button"
                                className="btn-cancel"
                                disabled={loading}
                                onClick={() => setShowDeleteTooltip(false)}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        }
                      >
                        <button
                          type="button"
                          className="btn-danger"
                          disabled={loading}
                          onClick={() => setShowDeleteTooltip(!showDeleteTooltip)}
                        >
                          Click to delete your account
                        </button>
                      </Tippy>
                    </div>
                    <div className="option-details">
                      <small>
                        Deleting your account will destroy all your polls, submission responses, and
                        other linked data. <br />
                        This action cannot be undone.
                      </small>
                    </div>
                  </div>
                )}
              </OptionCard>
            </div>
          )}

          {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
          {/* <pre>{JSON.stringify(session, null, 2)}</pre> */}
        </ProfilePageWrapper>
      </SinglePageWrapper>
      <Footer />
      <PollmeFeedbackButton url="https://pollme.app/embed/pgOkSWLT5I/variation?type=feedback" />
    </ViewWrapper>
  );
};

const ProfileSessionWrapper = props => {
  const { session } = props;
  const router = useRouter();

  useEffect(() => {
    const checkIfSession = async () => {
      if (!session) {
        await localLogout(); // clear local storage data
        router.replace(`/login`);
      } else {
        await setLocalSession(session);
      }
    };
    checkIfSession();
  }, [session, router]);

  if (session) {
    return <Profile {...props} />;
  }
  return (
    <ViewWrapper>
      <HeadMeta />
      <SplashLoader />
    </ViewWrapper>
  );
};
export default ProfileSessionWrapper;
